import classNames from 'classnames';
import { FC, MouseEvent, memo } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import Icon from 'src/view/components/Controls/Icon/Icon';
import { InputType, TInputType } from '~/view/components/Controls/InputComponent/types';
import './style.scss';

interface IProps {
  type: TInputType;
  onPress: (event: MouseEvent<HTMLDivElement>) => void;
  size?: number;
  color?: string;
  className?: string;
}

const InputValueDisguise: FC<IProps> = ({ type, size = 23, color = theme.colors.gray2, onPress, ...props }: IProps): JSX.Element => {
  const icon: Icons = type === InputType.PASSWORD ? Icons.Disguise : Icons.UnDisguise;

  return (
    <div className={classNames('input-value-disguise', props.className)} onClick={onPress}>
      <Icon name={icon} size={size} color={color} className="input-value-disguise__icon" />
    </div>
  );
};

export default memo(InputValueDisguise);
